import React from 'react'

import TWControls from '../controls/TWControls'
import { Form } from '../controls/useForm'

const PartnerReminderPopup = ({ partner, remindPartner }) => {
	const submitHandler = e => {
		remindPartner(partner)
	}

	return (
		<Form onSubmit={submitHandler}>
			<div className="grid grid-cols-12 gap-4">
				<div className="col-span-12 newLocation__imageHolder">
					<p>{`Resend a partner invitation to ${partner.partnerUserId.name} at ${partner.partnerUserId.email}?`} </p>
				</div>
				<div className="col-span-12">
					<div className="newLocation__imageHolder">
						<TWControls.Button size="small" type="submit" text="Resend" />
					</div>
				</div>
			</div>
		</Form>
	)
}

export default PartnerReminderPopup
